/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React, { useEffect } from "react";
import styles from "./index.module.css";
// Redux
import { sampleAction } from "../../../actions";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const StepOneForm = ({
  step,
  setStep,
  layout: {
    sampleState,
    companyName,
    mobileNumber,
    email,
    address,
    password,
    isLoading,
    isSubmittedSuccessfully,
  },
  formValuesStepOne,
  formErrorsStepOne,
  handleOnChangeStepOne,
  handleOnClickStepOne,
}) => {
  useEffect(() => {
    if (step < 3) {
      if (step === 1 && isSubmittedSuccessfully) {
        setStep(step + 2);
      }
    }
  }, [isSubmittedSuccessfully]);

  return (
    <div className={styles.mainDiv}>
      <div className={styles.step}>Step 1/3</div>
      <div className={styles.welcome}>Welcome to Epinics Onboard!</div>
      <div className={styles.subTitle}>Enter Your Company Details to Start</div>
      <div className={styles.formDiv}>
        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label htmlFor="companyName">
              Your Company Name <span>*</span>
            </label>
            <input
              type="text"
              id="companyName"
              value={formValuesStepOne.companyName}
              onChange={e => {
                handleOnChangeStepOne("companyName", e);
              }}
              placeholder="Ex: Thilaka Medical Store"
            />
            {formErrorsStepOne.companyName && (
              <div className={styles.error}>
                {formErrorsStepOne.companyName}
              </div>
            )}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="mobileNumber">
              Company Mobile Number <span>*</span>
            </label>
            <input
              id="mobileNumber"
              maxlength="10"
              placeholder="07XXXXXXXX"
              value={formValuesStepOne.mobileNumber}
              onChange={e => {
                handleOnChangeStepOne("mobileNumber", e);
              }}
            />
            {formErrorsStepOne.mobileNumber && (
              <div className={styles.error}>
                {formErrorsStepOne.mobileNumber}
              </div>
            )}
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="email">
              Company Email
            </label>
            <input
              type="text"
              id="email"
              placeholder="xxx@mail.com"
              value={formValuesStepOne.email}
              onChange={e => {
                handleOnChangeStepOne("email", e);
              }}
            />
            {formErrorsStepOne.email && (
              <div className={styles.error}>{formErrorsStepOne.email}</div>
            )}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="address">
              Address
            </label>
            <input
              type="text"
              id="address"
              value={formValuesStepOne.address}
              onChange={e => {
                handleOnChangeStepOne("address", e);
              }}
            />
            {formErrorsStepOne.address && (
              <div className={styles.error}>{formErrorsStepOne.address}</div>
            )}
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}></div>
        </div>
      </div>
    </div>
  );
};

StepOneForm.propTypes = {
  sampleAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  layout: state.layoutState,
});

export default connect(mapStateToProps, {
  sampleAction,
})(StepOneForm);
